import React, {useState} from "react";
import style from "./SideBar.module.css";
import {Button} from "react-bootstrap";
import {callConvertTrialGameToRegular} from "../api/UserService";
import {useTranslation} from "react-i18next";

function EndTrialGame(props) {
    const { t, i18n } = useTranslation('translation', { keyPrefix: 'endTrialGame' });
    const [perserveHistory, setPreserveHistory] = useState(true)
    function convertTrialGameToRegular() {
        callConvertTrialGameToRegular(props.gameState.id, perserveHistory, () => {}, ()=>{})
    }

    function setPreserve(event) {
        if (event.target.value === "with") {
            setPreserveHistory(true)
        } else if (event.target.value === "without") {
            setPreserveHistory(false)
        }
    }

    return (
        <div className={style.historyRowEndGameTile}>
            {/*Trial game section*/}
            {props.gameState?.is_over && <div className={style.historyRowEndGameitem}>{t('trialGameFinished')}</div>}
            {props.loginValid &&
                <>
                    <div className={style.historyRowEndGameitem}>{t('finishTrialStartRegularQ')}</div>
                    <div className={style.historyRowEndGameitem}>
                        <fieldset className={style.historyRowEndGameitemConvertSelector}>
                            <div>
                                <input type="radio" id="huey" name="drone" value="with" checked={perserveHistory} onChange={setPreserve}/>
                                <label htmlFor="huey">{t('withSavingHistory')}</label>
                            </div>
                            <div>
                                <input type="radio" id="dewey" name="drone" value="without" checked={!perserveHistory} onChange={setPreserve}/>
                                <label htmlFor="dewey">{t('noHistorySave')}</label>
                            </div>
                        </fieldset>
                    </div>
                    <div className={style.historyRowEndGameitem}>
                        <Button
                            variant="primary"
                            style={{backgroundColor: "#59619B", margin: "5px", width: "60px"}}
                            onClick={convertTrialGameToRegular}
                        > {t('yes')} </Button>
                    </div>
                </>
            }
            {(!props.loginValid && !props.gameState?.is_over) && <div className={style.historyRowEndGameitem}>{t('trialGame')}</div>}
            {/*END Trial game section*/}
        </div>
    )
}

export default EndTrialGame